"use strict";

var _classCallCheck = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _ImageCell = _interopRequireDefault(require("./ImageCell"));
var _TextCell = _interopRequireDefault(require("./TextCell"));
var _VideoCell = _interopRequireDefault(require("./VideoCell"));
var _ButtonCell = _interopRequireDefault(require("./ButtonCell"));
var _LanguageSelectionCell = _interopRequireDefault(require("./LanguageSelectionCell"));
var _EmailFormCell = _interopRequireDefault(require("./EmailFormCell"));
var _reactRouterDom = require("react-router-dom");
var _CarouselCell = _interopRequireDefault(require("./CarouselCell"));
var _TabMenuCell = _interopRequireDefault(require("./TabMenuCell"));
var _CocaFormCell = _interopRequireDefault(require("./CocaFormCell"));
var _ProductsListCell = _interopRequireDefault(require("./ProductsListCell"));
var _FormCell = _interopRequireDefault(require("./FormCell"));
var _MemoryGameCell = _interopRequireDefault(require("./MemoryGameCell"));
var _IframeCell = _interopRequireDefault(require("./IframeCell"));
var _utils = require("../utils");
var _reactIntl = require("react-intl");
var _WheelCell = _interopRequireDefault(require("./WheelCell"));
var _Wheel2Cell = _interopRequireDefault(require("./Wheel2Cell"));
var _PlanCell = _interopRequireDefault(require("./PlanCell"));
var _QuizzCell = _interopRequireDefault(require("./QuizzCell"));
var _RankingCell = _interopRequireDefault(require("./RankingCell"));
var _ButtonDiffuseCell = _interopRequireDefault(require("./ButtonDiffuseCell"));
var _AgendaCell = _interopRequireDefault(require("./AgendaCell"));
var _Agenda2Cell = _interopRequireDefault(require("./Agenda2Cell"));
var _AgendaTableauCell = _interopRequireDefault(require("./AgendaTableauCell"));
var _Products2Cell = _interopRequireDefault(require("./Products2Cell"));
var _BatibouwFinderCell = _interopRequireDefault(require("./BatibouwFinderCell"));
var _PhotoCell = _interopRequireDefault(require("./PhotoCell"));
var _PhotoboothCell = require("./PhotoboothCell");
var _ModernPhotoboothCell = require("./ModernPhotoboothCell");
var _PhotoboothGifCell = _interopRequireDefault(require("./PhotoboothGifCell"));
var _PhotoboothGifCell2 = _interopRequireDefault(require("./PhotoboothGifCell2"));
var _PhotoboothOBSCell = _interopRequireDefault(require("./PhotoboothOBSCell"));
var _PhotoboothLandscape = _interopRequireDefault(require("./PhotoboothLandscape"));
var _CardsGame = _interopRequireDefault(require("./CardsGame.cell"));
var _PhotoboothChoiceCell = _interopRequireDefault(require("./PhotoboothChoiceCell"));
var _PhotoboothMultipleGifCell = _interopRequireDefault(require("./PhotoboothMultipleGifCell"));
var _GivenchyPhotoboothCell = _interopRequireDefault(require("./GivenchyPhotoboothCell"));
var _JohnnieWalkerPhotoboothCell = _interopRequireDefault(require("./JohnnieWalkerPhotoboothCell"));
var _HARIBOPhotoboothCell = _interopRequireDefault(require("./HARIBOPhotoboothCell"));
var _PhotoboothStripePrintCell = _interopRequireDefault(require("./PhotoboothStripePrintCell"));
var _HtmlCell = _interopRequireDefault(require("./HtmlCell"));
var _SendEmailCell = _interopRequireDefault(require("./SendEmailCell"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var CellView = /*#__PURE__*/function (_react$default$Compon) {
  function CellView() {
    var _this;
    _classCallCheck(this, CellView);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, CellView, [].concat(args));
    _defineProperty(_this, "cellContent", function (cell) {
      switch (cell.cell_type) {
        case "image":
          return /*#__PURE__*/_react.default.createElement(_ImageCell.default, _this.props);
        case "text":
          return /*#__PURE__*/_react.default.createElement(_TextCell.default, _this.props);
        case "video":
          return /*#__PURE__*/_react.default.createElement(_VideoCell.default, _this.props);
        case "button":
          return /*#__PURE__*/_react.default.createElement(_ButtonCell.default, _this.props);
        case "form":
          return /*#__PURE__*/_react.default.createElement(_FormCell.default, _this.props);
        case "email_form":
          return /*#__PURE__*/_react.default.createElement(_EmailFormCell.default, _this.props);
        case "language_selection":
          return /*#__PURE__*/_react.default.createElement(_LanguageSelectionCell.default, _this.props);
        case "carousel":
          return /*#__PURE__*/_react.default.createElement(_CarouselCell.default, _this.props);
        case "tab_menu":
          return /*#__PURE__*/_react.default.createElement(_TabMenuCell.default, _this.props);
        case "coca_form":
          return /*#__PURE__*/_react.default.createElement(_CocaFormCell.default, _this.props);
        case "products_list":
          return /*#__PURE__*/_react.default.createElement(_ProductsListCell.default, _this.props);
        case "memory_game":
          return /*#__PURE__*/_react.default.createElement(_MemoryGameCell.default, _this.props);
        case "iframe":
          return /*#__PURE__*/_react.default.createElement(_IframeCell.default, _this.props);
        case "wheel":
          return /*#__PURE__*/_react.default.createElement(_WheelCell.default, _this.props);
        case "wheel2":
          return /*#__PURE__*/_react.default.createElement(_Wheel2Cell.default, _this.props);
        case "plan":
          return /*#__PURE__*/_react.default.createElement(_PlanCell.default, _this.props);
        case "quizz":
          return /*#__PURE__*/_react.default.createElement(_QuizzCell.default, _this.props);
        case "ranking":
          return /*#__PURE__*/_react.default.createElement(_RankingCell.default, _this.props);
        case "button_diffuse":
          return /*#__PURE__*/_react.default.createElement(_ButtonDiffuseCell.default, _this.props);
        case "agendas":
          return /*#__PURE__*/_react.default.createElement(_AgendaCell.default, _this.props);
        case "agendas2":
          return /*#__PURE__*/_react.default.createElement(_Agenda2Cell.default, _this.props);
        case "agenda_tableau":
          return /*#__PURE__*/_react.default.createElement(_AgendaTableauCell.default, _this.props);
        case "products2":
          return /*#__PURE__*/_react.default.createElement(_Products2Cell.default, _this.props);
        case 'batibouw_finder':
          return /*#__PURE__*/_react.default.createElement(_BatibouwFinderCell.default, _this.props);
        case 'photo':
          return /*#__PURE__*/_react.default.createElement(_PhotoCell.default, _this.props);
        case 'photobooth':
          return /*#__PURE__*/_react.default.createElement(_PhotoboothCell.Photobooth, _this.props);
        case 'modern_photobooth':
          return /*#__PURE__*/_react.default.createElement(_ModernPhotoboothCell.ModernPhotobooth, _this.props);
        case 'photobooth_gif':
          return /*#__PURE__*/_react.default.createElement(_PhotoboothGifCell.default, _this.props);
        case 'photobooth_gif2':
          return /*#__PURE__*/_react.default.createElement(_PhotoboothGifCell2.default, _this.props);
        case 'photobooth_obs':
          return /*#__PURE__*/_react.default.createElement(_PhotoboothOBSCell.default, _this.props);
        case 'photobooth_landscape':
          return /*#__PURE__*/_react.default.createElement(_PhotoboothLandscape.default, _this.props);
        case 'cards_game':
          return /*#__PURE__*/_react.default.createElement(_CardsGame.default, _this.props);
        case 'photobooth_choice':
          return /*#__PURE__*/_react.default.createElement(_PhotoboothChoiceCell.default, _this.props);
        case 'photobooth_multiple_gif':
          return /*#__PURE__*/_react.default.createElement(_PhotoboothMultipleGifCell.default, _this.props);
        case 'givenchy_photobooth':
          return /*#__PURE__*/_react.default.createElement(_GivenchyPhotoboothCell.default, _this.props);
        case 'johnnie_walker_photobooth':
          return /*#__PURE__*/_react.default.createElement(_JohnnieWalkerPhotoboothCell.default, _this.props);
        case 'haribo_photobooth':
          return /*#__PURE__*/_react.default.createElement(_HARIBOPhotoboothCell.default, _this.props);
        case 'photobooth_stripe_print':
          return /*#__PURE__*/_react.default.createElement(_PhotoboothStripePrintCell.default, _this.props);
        case 'html':
          return /*#__PURE__*/_react.default.createElement(_HtmlCell.default, _this.props);
        case 'send_email':
          return /*#__PURE__*/_react.default.createElement(_SendEmailCell.default, _this.props);
        default:
          return null;
      }
    });
    return _this;
  }
  _inherits(CellView, _react$default$Compon);
  return _createClass(CellView, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
      return (0, _utils.shouldCellComponentUpdate)(this.props, nextProps) || this.state !== nextState;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        cell = _this$props.cell,
        linkFromPageId = _this$props.linkFromPageId,
        changeLocale = _this$props.changeLocale,
        history = _this$props.history,
        logEvent = _this$props.logEvent,
        page = _this$props.page;
      // The photobooth is interactive over its whole surface, so wrapping it in a link/button makes
      // any tap during capture leave the booth. It renders its own corner hotspot for
      // links_to_page_id instead; the other link modes simply don't apply. All three share one
      // dropdown in CommonCellEditor ("Retour" + the page list), so guarding only one branch would
      // leave the malfunction a menu item away.
      // Keyed on cell_type alone: fullscreen_reveal isn't in the admin's page query
      // (front/src/queries/pages.js), so it reads undefined here and can't gate this.
      var wrapsWholeCell = cell.cell_type !== 'photobooth_gif2';
      if (cell.is_back_link && wrapsWholeCell) {
        return /*#__PURE__*/_react.default.createElement("button", {
          style: {
            border: 'none',
            fontSize: 'inherit',
            background: 'inherit',
            padding: 0,
            color: 'inherit',
            textDecoration: 'inherit',
            cursor: 'pointer'
          },
          className: 'tsk-backlink',
          id: cell.id,
          onClick: function onClick() {
            logEvent('back', {
              cellId: cell.id,
              pageId: page.id
            });
            history.goBack();
          }
        }, this.cellContent(cell));
      } else if (Array.isArray(cell.links_to_random_page_ids) && cell.links_to_random_page_ids.length > 0 && wrapsWholeCell) {
        return /*#__PURE__*/_react.default.createElement("div", {
          style: {
            cursor: 'pointer',
            width: '100%',
            height: '100%'
          },
          onClick: function onClick() {
            var pages = cell.links_to_random_page_ids;
            var toPageId = pages[Math.floor(Math.random() * pages.length)];
            logEvent('click', {
              cellId: cell.id,
              pageId: page.id,
              toPageId: toPageId
            });
            if (!!cell.links_to_language) changeLocale(cell.links_to_language);
            history.push("/page/".concat(toPageId));
          }
        }, this.cellContent(cell));
      } else if (!!cell.links_to_page_id && wrapsWholeCell) {
        if (!!cell.links_to_language) {
          return /*#__PURE__*/_react.default.createElement("div", {
            onClick: function onClick() {
              return changeLocale(cell.links_to_language);
            }
          }, linkFromPageId(cell.links_to_page_id, this.cellContent(cell)));
        } else {
          return linkFromPageId(cell.links_to_page_id, this.cellContent(cell));
        }
      }
      return this.cellContent(cell);
    }
  }]);
}(_react.default.Component);
_defineProperty(CellView, "whyDidYouRender", true);
var _default = exports.default = (0, _reactIntl.injectIntl)((0, _reactRouterDom.withRouter)(CellView));